import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Constants } from '../constants';
import { MiteventsService } from '../../mitevents.service';
import { ThankYouPopupComponent } from '../../common/thank-you-popup/thank-you-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { SeoService } from '../seo.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  contactForm!: FormGroup;
  showThankYouPopUp: boolean = false;
  baseurl = Constants.baseUrl;
  thankYouVisible: boolean = true;
  charsRemaining: number = 500;
  readonly maxLength: number = 500;
  baseUrl=Constants.baseUrl;
  message: string = '';
  loading = false;
 
  dialogRef!: MatDialogRef<ThankYouPopupComponent>;

  phoneForm = new FormGroup({
    phone: new FormControl("", [Validators.required])
  });
  contact_emailError: boolean = false;
 

  emailErrorElement="";




  constructor(private fb: FormBuilder, private http: HttpClient, private titleService: Title,
    private metaService: Meta, private eventService: MiteventsService, private dialog: MatDialog,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,private seoService:SeoService) {
      this.contactForm = this.fb.group({
        country: [''] // initial value is empty
      }); 
    
    
    }
    resetEmailErr(){   
      this.emailErrorElement="";
    }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Connect with Us');

    this.metaService.addTags([
      { name: 'description', content: 'We Love To Hear From You!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Connect with Us' },
      { property: 'og:url', content: 'https://mitresource.com/contact/' },
      { property: 'og:image', content: '' },
      { property: 'og:description', content: 'We Love To Hear From You.' },
    ]);
  }
  
  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Maganti IT Resources, LLC",
  "image": "https://mitresource.com/assets/images/homepage/update-mitimage.png",
  "@id": "",
  "url": "https://mitresource.com/",
  "telephone": "1-855-217-4637",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "21 State St, Waterbury, CT 06702",
    "addressLocality": "Connecticut",
    "addressRegion": "CT",
    "postalCode": "CT 06702",
    "addressCountry": "US"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  },
  "sameAs": [
    "https://www.linkedin.com/company/maganti-it-resources-llc/mycompany/",
    "https://www.instagram.com/magantiit/",
    "https://twitter.com/mitresource"
  ] 
}`;

    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
    this.formInit();

    this.contactForm.get('contactMessage')?.valueChanges.subscribe(() => {
      this.updateCharsRemaining();
    });
    // this.contactForm.get('country')?.valueChanges.subscribe((selectedCountryCode: string) => {
    //   const phoneControl = this.contactForm.get('contactPhone');
    //   const currentPhone = phoneControl?.value || '';
    //   phoneControl?.setValue(`${selectedCountryCode}${currentPhone}`);
    // });

    this.contactForm.get('contactEmail')?.valueChanges.subscribe(() => {
      this.changeContactEmail();
    });
  }

  get contactNameError(): string {
    const control = this.contactForm.get('contactName');
    if (control?.hasError('required')) return 'Full name is required';
    if (control?.hasError('invalidName')) return 'First name can accept spaces, alphabet and hyphen only.';
    else if (control?.hasError('minlength')) {
      return 'Full Name must be at least 2 characters long without spaces';
    } else if (control?.hasError('maxlength')) {
      return 'Full Name cannot exceed 30 characters';
    }
    else if (control?.hasError('pattern')){
      return 'Enter valid Name'
    }
    return '';
  }

  get contactEmailError(): string {
    const control = this.contactForm.get('contactEmail');
    if (control?.hasError('required')) return 'Email is required';
    if (control?.hasError('email')) return 'Enter a valid email';
    if (control?.hasError('pattern')) return 'Enter a valid email';
    // if (control?.hasError('existingEmail')) return 'Email is already exist.';
    return '';
  }

  get contactPhoneError(): string {
    const control = this.contactForm.get('contactPhone');
    if (control?.hasError('required')) return 'Phone number is required';
    if (control?.hasError('pattern')) return 'Phone number must contain only digits';
    if (control?.hasError('minlength')) return 'Phone number is invalid';
    if (control?.hasError('maxlength')) return 'Phone number is invalid';
    return '';
  }
  


  updateCharsRemaining(): void {
    const contactMessageValue = this.contactForm.get('contactMessage')?.value || '';
    this.charsRemaining = this.maxLength - contactMessageValue.length;
  }
  onMessageChange(): void {
    const messageControl = this.contactForm.get('contactMessage');
    this.charsRemaining = 500 - (messageControl?.value?.length || 0);
  }
  
  formInit(){
    // this.contactForm = this.fb.group({
    //   contactName: ['', [Validators.required,Validators.maxLength(50),Validators.pattern(/^[a-zA-Z]{3,}([ ]?[a-zA-Z]+)*$/),]],
    //   contactEmail: ['',[Validators.required,this.customEmailValidator()]],
    //   contactPhone: ['', [Validators.required,Validators.minLength(10),Validators.maxLength(13), Validators.pattern(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/)]],
    //   contactMessage: ['', [Validators.maxLength(this.maxLength)]],
    //   country: ['+91', Validators.required] 

    // });
    this.contactForm = this.fb.group({
      contactName: ['', [Validators.required,Validators.maxLength(50),Validators.pattern(/^[a-zA-Z]{3,}([ ]?[a-zA-Z]+)*$/)]],
      contactEmail: ['',[Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z][\w\-_.]*[a-zA-Z0-9]@[a-zA-Z]+\.[a-zA-Z]{2,3}$/)]],
      contactPhone: ['', [Validators.required,Validators.maxLength(13),Validators.minLength(8), Validators.pattern(/^\+?\d{1,15}$/) ]],
      contactMessage: ['', [Validators.maxLength(this.maxLength)]],
      country: ['+91', Validators.required] 

    });
  }

  onSubmit(): void {
    if (this.contactForm.valid) {
      this.loading = true;
      this.contactForm.disable();
       // Hide scrolling
    this._document.body.style.overflow = 'hidden';
        const formData = new FormData();
        formData.append('fullName', this.contactForm.value.contactName);
        formData.append('email', this.contactForm.value.contactEmail);
        formData.append('contactNumber', this.contactForm.value.contactPhone);
        formData.append('message', this.contactForm.value.contactMessage);
        formData.append('type', 'contact_Form');
        
        this.eventService.SendContactDetails(formData).subscribe(
            (res: any) => {
                // console.log('Success:', res);
                this.contactForm.reset();
               this.loading = false; 
                      // Restore scrolling
        this._document.body.style.overflow = 'auto';
                this.dialogRef = this.dialog.open(ThankYouPopupComponent, {
                  data: {
                    title: 'Thank You for Contacting Us!',
                    message: 'Our team will get back to you shortly with a response. '
                  }
                });
                setTimeout(() => {
                  this.dialogRef.close();
                  this.dialog.closeAll();
                  this.formInit();
                 // Hide loader
                  this.contactForm.enable();
                }, 4000);
              },
              (err: HttpErrorResponse) => {
                this.loading = false;
                      // Restore scrolling
        this._document.body.style.overflow = 'auto';
                this.contactForm.enable();
                // if (err.status === 409) {
                //   this.emailErrorElement = "Email already exists.";
                // } else {
                //   console.error('An error occurred:', err);
                // }
              }
            );
          } else {
            this.contactForm.markAllAsTouched();
          }
          this.contactForm.enable();
}
  handleError(err: HttpErrorResponse): string {
    throw new Error('Method not implemented.');
  }

  setErrorState(errorMessage: string, isError: boolean): void {
    const contactEmailControl = this.contactForm.get('contactEmail');
    if (isError) {
     this.contact_emailError=true;
     } else {
      this.contact_emailError=false;
    }}
closePopup(): void {
  this.showThankYouPopUp = false;  
}
 addHover(event: Event): void {
    const target = event.target as HTMLElement;
    target.classList.add('hover');
  }
  
  removeHover(event: Event): void {
    const target = event.target as HTMLElement;
    target.classList.remove('hover');
  }
 changeContactEmail(): void {
    const contactEmail = this.contactForm.get('contactEmail');
    const emailRegexp =  /^[a-zA-Z][\w\-_.]*[a-zA-Z0-9]@[a-zA-Z]+\.[a-zA-Z]{2,3}$/;
    

    if (contactEmail?.hasError('required')) {
      this.setErrorState("Email is required", true);
    } else if (!contactEmail?.value.match(emailRegexp)) {
      this.setErrorState("Enter a valid business email", true);
    } else {
      this.setErrorState("", false);
    }
    
    // Enable or disable the form submit button
    this.toggleSubmitButton();
  }

  @ViewChild('submitBtn') submitButton!: ElementRef<HTMLButtonElement>;

  toggleSubmitButton() {
      if (this.submitButton) {
          this.submitButton.nativeElement.disabled = true;
      }
  } 
  onPhoneInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 13) {
      input.value = input.value.slice(0, 13); // Trim to 13 characters
      this.contactForm.get('contactPhone')?.setValue(input.value);
    }
  }
  
}
